export default __webpack_public_path__ + "static/media/element_86.d46b13de.webp";